import config from 'local_modules/app-config'


const isTestApi = config.api === 'test'
const isDevApi  = config.env === 'development'

const constants = {
  smartSarov: {
    layers: '/nginxApi.php?get=config',
    city: '/nginxApi.php?get=city',
    userData: '/nginxApi.php?get=user',
    weather: '/ajax.php?action=loadWeather',
    // weather: '/smartSensor/rest/sensor/26/latest',
    pressure: '/smartSensor/rest/sensor/25/latest',
    humidity: '/smartSensor/rest/sensor/27/latest',
    radiation: '/smartSensor/rest/sensor/23/latest',
    waterLevel: '/smartSensor/rest/sensor/29/latest',
    lightning: '/smartSensor/rest/sensor/28/latest',
    weatherCode: '/ajax.php?action=getWeatherCode',
    chat: '/ajax.php?action=getEvents&r=134.4520306176691&json={"f":[],"s":0,"k":[1],"q":""}',
    // chat: '/ajax.php?action=getEvents&r=570.9974833023907',
    terms: '/mob_terms.php',
    login: '/?login', // ={layerId}
    auth: '/ajax.php?action=login&r=',

    // upload
    uploadBase64: '/uploadBase64image.php',

    // ASUDD
    transport: '/ajax.php?action=getCityroads&json=%7B%7D',
    smartSensorAccess: '/smartSensor/rest/access',
    smartSensorList: '/smartSensor/rest/sensor',
    smartSensorMeasures: '/smartSensor/rest/measure',

    // accessible
    accessible: `/ajax.php?action=getDisabilities`,
    updateAccessible: `/ajax.php?action=operateDisabilities`,
  },
  cityEconomy: {
    whoami: '/whoami',
    org: '/org',
    metric: '/metric/org',
    reportEconomy: '/metric/economy',
    reportOperations: '/metric/overSum',
    param: '/metric/param', // /latest
    locations: '/locations',
  },
  dashboard: {
    whoami: '/whoami',

    problems: '/problems',
    covidAnalys: '/covid',

    sensors: '/sensors/offline',
    blackouts: '/blackouts',
    electric: '/sensors/electric',
    accidents: '/accidents',

    houses: '/houses',
    bus: '/bus',
    cleaning: '/cleaning',
    sales: '/sales',
    covid: '/hotline',
    kb50: '/hotline/kb50',
    trash: '/trashcan',

    water: '/sensors/water',
    salesSchool: '/sales/school',
    metricsAge: '/metrics/age',
    metricsDate: '/metrics/date',
  },
  news: {
    list: '/list',
    add: '/add',
    update: '/update',
    delete: '/delete', // /:newsId
    img: '/img', // ?id=
  },
  marketplaceExt: {
    order: '/order/food', // + /{id} +/status
  },
  marketplace: {
    whoami: '/whoami',
    feedback: '/feedback',

    tariffLabels: '/schedule/lbl',
    tariffSessions: '/schedule/session',
    tariffCategory: '/tariff/category',
    tariffTime: '/tariff/time',
    tariff: '/tariff',

    sessionsByLabel: '/schedule/patternsByLbl', // {labelId},
    generateSchedule: '/schedule', // {yyyy}/{mm}/{dd}/{count}
    statisticsCategories: '/subscription/subscriber/label',
    setQuotaAndDescription: '/schedule', // /scheduleId/quota

    bookingTotal: '/booking/total',
    booking: '/booking/book',
    bookingOrder: '/booking/order', // /:orderId

    environmentCreateArea: '/environment/create/area',
    environmentAreaTools: '/environment/tool/area',

    environmentArea: '/environment/area',
    environmentAreaImage: '/environment/area/img',
    environmentToolType: '/environment/tool/type',
    environmentTool: '/environment/tool', // :area.id
    environmentServices: '/environment/service',
    environmentTrainersParams: '/tariff/learn',

    learn: '/learn', // :tool.id
    learnGroup: '/learn/group', // :tool.id
    learnSubscriber: '/learn/subscriber', // :area.id
    learnGroupBooking: '/learn/booking', // :tool.id
    learnSubscription: '/learn/subscription', // /{subscriptionId}/{recalcCount}
    environmentTrainer: '/learn/trainer',
    learnCreate: '/learn/create/pervSubscription',

    ticket: '/tariff/subscription',
    learnTariff: '/tariff/learn',

    cashierScheduleTickets: '/cashier/scheduled',
    cashierTickets: '/cashier/subscribed',
    cashierTicketsActivate: '/cashier/subscribed/activate',

    cashierLearnList: '/cashier/learn',
    cashierLearnPay: '/cashier/learn/pay',
    cashierLearnListUse: '/cashier/learn/use',

    statisticLearn: '/stat/learn', // trainerID
    statisticPayment: '/stat/payed',
    statisticLearning: '/stat/learn/area',
    statisticSubscribers: '/stat/subscribers',
    statisticPaymentSuccess: '/stat/payed/success',
    statisticFullTool: '/stat/payed/success/area',

    userOrders: '/user/orders',
    userCancelOrder: '/booking/cancel', // order id
    userCancelOrderPartial: '/booking/cancel/partial', // order id

    cashierCancelList: '/cashier/cancel',
  },
  edu: {
    whoami: '/whoami',
    feedback: '/feedback',

    categories: '/nomenclature/categories',
    schoolStages: '/nomenclature/stage',

    schools: '/environment/school',
    dates: '/environment/dates',
    datesAvailable: '/environment/dates/available',
    cashiersList: '/environment/cashier/list',
    cashierSettings: '/environment/cashier/settings',

    schoolClass: '/cashier/class',
    cashierIssue: '/cashier/issue',
    cashierSchool: '/cashier/school',
    cashierRefund: '/cashier/refund/list',
    cashierOfflineSales: '/cashier/offline/sale',

    orderTotal: '/order/food/total',
    orderCreate: '/order/food/create',
    orderData: '/order/food',
    orderCancel: '/order/food/cancel',
    orderCancelPartial: '/order/food/cancel/partial',

    cashierCancelPartial: '/cashier/refund/partial/make/',

    adminCancelBulkSchool: '/cashier/refund/school',
    adminCancelBulkClass: '/cashier/refund/class',

    statAll: '/stat/all',
    statClass: '/stat/class',
    statSchool: '/stat/school',
    statSuccess: '/stat/success',
    statPositions: '/stat/positions',
    statPositionsPayed: '/stat/payedDate/positions',
    statPositionsPayedTotal: '/stat/payedDate/school',
    // statOfflineSales: '/stat/offline/sale',

    nomenclatureSchool: '/nomenclature/r/school',
  },
  rpc: {
    whoami: '/whoami',
    feedback: '/feedback',

    categories: '/nomenclature/categories',
    schoolStages: '/nomenclature/stage',

    schools: '/environment/school',
    dates: '/environment/dates',
    datesAvailable: '/environment/dates/available',
    cashiersList: '/environment/cashier/list',
    cashierSettings: '/environment/cashier/settings',

    schoolClass: '/cashier/class',
    cashierIssue: '/cashier/issue',
    cashierSchool: '/cashier/school',
    cashierRefund: '/cashier/refund/list',
    cashierOfflineSales: '/cashier/offline/sale',

    orderTotal: '/order/food/total',
    orderCreate: '/order/food/create',
    orderData: '/order/food',
    orderCancel: '/order/food/cancel',
    orderCancelPartial: '/order/food/cancel/partial',

    cashierCancelPartial: '/cashier/refund/partial/make/',
    
    adminCancelBulkSchool: '/cashier/refund/school',
    adminCancelBulkClass: '/cashier/refund/class',
    
    statAll: '/stat/all',
    statClass: '/stat/class',
    statSchool: '/stat/school',
    statSuccess: '/stat/success',
    statPositions: '/stat/positions',
    statPositionsPayed: '/stat/payedDate/positions',
    statPositionsPayedTotal: '/stat/payedDate/school',
    // statOfflineSales: '/stat/offline/sale',

    nomenclatureSchool: '/nomenclature/r/school',
  },
  lscSchedules: {
    cover: '/cover',

    login: '/login',
    drivers: '/drivers',
    conductors: '/conductors',
    buses: '/buses',
    routes: '/routes',
    getReport: '/getReport',

    driversSchedule: '/drivers/schedule', // ?dateMin=2019-03-11&dateMax=2019-03-11
    conductorsSchedule: '/conductors/schedule', // ?dateMin=2019-03-11&dateMax=2019-03-11
    busesSchedule: '/buses/techAvailability', // ?dateMin=2019-03-11&dateMax=2019-03-11

    driversScheduleCodes: '/drivers/schedule/codes',
    conductorsScheduleCodes: '/conductors/schedule/codes',
    busesScheduleCodes: '/buses/techAvailability/codes',

    driversScheduleSet: '/drivers/schedule/set',
    conductorsScheduleSet: '/conductors/schedule/set',
    busesScheduleSet: '/buses/techAvailability/set',

    driversScheduleClear: '/drivers/schedule/clear',

    orderSchedule: '/order', // ?date=2019-03-11
    orderScheduleOld: '/order/oldFormat', // ?date=2019-03-11
    generateOrder: '/order/generation', // date=2019-03-11 / dayType auto | weekday | day off
    generateOrderStatus: '/order/generation/status', // ?dateMin=2019-03-11&dateMax=2019-03-11

    driversAdd: '/drivers/add',
    conductorsAdd: '/conductors/add',
    busesAdd: '/buses/add',

    driversRemove: '/drivers/remove', // ?driversId
    conductorsRemove: '/conductors/remove', // ?conductorsId
    busesRemove: '/buses/remove', // ?busesId

    driversUpdate: '/drivers/update', // post
    conductorsUpdate: '/conductors/update', // post
    busesUpdate: '/buses/update', // post

    busesFilterData: '/buses/filterData',
    conductorsFilterData: '/conductors/filterData',
    driversFilterData: '/drivers/filterData',

    // schedule edit
    orderManualFilter: '/order/manual/filter',
    orderManualSet: '/order/manual/set',

    driversScheduleGenerate: '/drivers/schedule/generate',
  },
  lscTransportControl: {
    transportationCount: '/transportation/count', //?busNumber=603,616,К594ТН152&routeNumber=2А,1,9&startDate=2018-12-01&endDate=2019-02-01&limit=1&offset=45
    transportation: '/transportation', //?busNumber=603,616,К594ТН152&routeNumber=2А,1,9&startDate=2018-12-01&endDate=2019-02-01&limit=1&offset=45
    routeNumbers: '/routeNumbers',
    busNumbers: '/busNumbers',

    violationsCount: '/violations/count', // - нарушения
    violations: '/violations', // - ?busNumber=Е836ЕН52,М418ВА152&routeNumber=1,4&startDate=2019-03-11&endDate=2019-03-12&limit=10&offset=1
    violationsBuses: '/violations/buses',
    violationRoutes: '/violations/routes',

    deviationsCount: '/deviations/count',
    deviations: '/deviations', // - ?busNumber=603,616&routeNumber=2А,1,9&startDate=2019-05-01&endDate=2019-05-10&limit=100&offset=45
    deviationsBuses: '/deviations/buses',
    deviationsRoutes: '/deviations/routes',
  },
  voting: {
    votes: '/getVoting',
    myVotes: '/getUserVoting',
    getShortNews: '/getShortNews', // ?type
    deleteNews: '/deleteNews', // ?id=34610
    getNews: '/getNews',
    setNews: '/setNews',

    // new
    setImage: '/image',
    getUser: '/user',
    getPoll: '/poll/full',
    setPoll: '/poll',
    setQuestion: '/question',
    setQuestions: '/questions',
    setAnswer: '/answer',
    getTags: '/tag',
    setVote: '/vote', // ?entityId=&questionId=
    getVote: '/voting', // ?entityId=&questionId=
    getPeopleVotesCount: '/votingPeople', // ?pollId=
  },
  asuddWs: {
    state: '/ws/state',
    online: '/ws/online',
  },
  asudd: {
    root: '/',
    trafficLight: '/trafficLight',
    program: '/trafficLight/program', // /<PROG ID>
    phase: '/trafficLight/phase', // /<PHASE ID>
    whoami: '/whoami',
    schedule: '/trafficLight/schedule',
    state: '/state',
    log: '/state/log',
    logControl: '/state/log/control'
  },
  trassir: {
    channel: '/channel',
  },
  traffic: {
    road: '/road', // road list
    roadUpdate: '/road/update',
    roadSplit: '/road/split',
    roadConcat: '/road/concat',
    transport: '/transport/road', // road speed
    sector: '/transport/sector', // road speed

    footway: '/footway', // sidewalks
    footwayUpdate: '/footway/update', // sidewalks
  },
  trafficWs: {
    transport: '/road',
  },
  transport: {
    whoami: '/whoami',
    env: '/env',
    type: '/env/type',
    owner: '/env/owner',

    route: '/bus/env/route',
    period: '/bus/schedule/period/type',
    routeStations: '/bus/env/route/station',
    routeGraph: '/bus/env/route/graph',
    graph: '/bus/env/graph',
    station: '/bus/env/station',
    parking: '/bus/env/parking',
    plans: '/bus/order',
    copy: '/bus/order/copy',
    orderSchedule: '/bus/order/schedule', ///<YEAR>/<MONTH>/<DAY>[?rid=<route ID> | /tag]
    routeOrder: '/bus/order/schedule/routeOrder', /// /routeId

    driver: '/bus/personal/driver',
    cashier: '/bus/personal/cashier',

    schedule: '/bus/schedule',
    schedulePeriod: '/bus/schedule/period',
  },
  transportWs: {
    state: '',
    bus: '/bus',
    online: '/online',
  },
  heroes: {
    list: '/',
    all: '/all',
    my: '/own',
    add: '/add',
    update: '/update',
    moderate: '/moderate', // ?id=
    delete: '/delete', // /:newsId
    img: '/img', // ?id=
  },
  accidentInfoWs: {
    state: '/state',
  },
  accidentInfo: {
    list: '/accident',
    message: '/message',
  },
  accessible: {
    whoami: '/whoami',
    list: '/list',
    area: '/area',
    sidewalk: '/sidewalk',
    crossing: '/crossing',
  },
}

const generateConstants = (host) => {
  const testApiUrls = {
    dashboard: 'https://smartsarov.ru/dashboard/rest',
    cityEconomy: 'https://smartsarov.ru/cityEconomy/rest',
    marketplace: 'https://smartsarov.ru/marketplace/rest',
    marketplaceExt: 'https://smartsarov.ru/marketplace-extension/rest',
    edu: 'https://smartsarov.ru/marketplace/edu/rest',
    rpc: 'https://smartsarov.ru/marketplace/rpc/rest',
    news: `https://smartsarov.ru/news/rest`,
    // edu: 'https://212.22.67.82:8443/edu-0.2',

    voting: 'https://smartsarov.ru/voting/rest',
    lscSchedules: 'https://smartsarov.ru/lsc-schedules/rest',
    lscTransportControl: 'https://smartsarov.ru/lsc-transport-control/rest',
    smartSarov: 'https://smartsarov.ru',

    asudd: 'https://smartsarov.ru/asud/rest',
    asuddWs: 'wss://smartsarov.ru/asud/rest',

    trassir: 'https://smartsarov.ru/trassir/rest',

    traffic: 'https://smartsarov.ru/trafficJams/rest',
    trafficWs: 'wss://smartsarov.ru/trafficJams/rest/ws',

    transport: 'https://smartsarov.ru/transport/rest',
    transportWs: 'wss://smartsarov.ru/transport/rest/ws',

    heroes: 'https://smartsarov.ru/heroes/rest',

    accidentInfo: 'https://smartsarov.ru/accidentInfo/rest',
    accidentInfoWs: 'wss://smartsarov.ru/accidentInfo/rest/ws',

    accessible: 'https://smartsarov.ru/accessible/rest',
  }

  const prodApiUrls = {
    dashboard: `https://${host}/dashboard/rest`,
    cityEconomy: `https://${host}/cityEconomy/rest`,
    marketplace: `https://${host}/marketplace/rest`,
    marketplaceExt: `https://${host}/marketplace-extension/rest`,
    news: `https://${host}/news/rest`,
    edu: `https://${host}/marketplace/edu/rest`,
    rpc: `https://${host}/marketplace/rpc/rest`,

    voting: 'https://smartsarov.ru/voting/rest',
    lscSchedules: `https://${host}/lsc-schedules/rest`,
    lscTransportControl: `https://${host}/lsc-transport-control/rest`,
    smartSarov: `https://${host}`,

    asudd: `https://${host}/asud/rest`,
    asuddWs: `wss://${host}/asud/rest`,

    trassir: `https://${host}/trassir/rest`,

    traffic: `https://${host}/trafficJams/rest`,
    trafficWs: 'wss://smartsarov.ru/trafficJams/rest/ws',

    transport: `https://${host}/transport/rest`,
    transportWs: `wss://${host}/transport/rest/ws`,

    heroes: `https://${host}/heroes/rest`,

    accidentInfo: `https://${host}/accidentInfo/rest`,
    accidentInfoWs: `wss://${host}/accidentInfo/rest/ws`,

    accessible: `https://${host}/accessible/rest`,
  }

  const apiUrls = isTestApi ? testApiUrls : prodApiUrls

  Object.keys(constants).forEach((appKey) => {
    const apiUrl = apiUrls[appKey]

    Object.keys(constants[appKey]).forEach((urlKey) => {
      constants[appKey][urlKey] = `${apiUrl}${constants[appKey][urlKey]}`
    })

    constants[appKey].apiUrl = apiUrl
  })
}


export {
  generateConstants,
  constants,
}
